// // TODO : LAST 2ND CHANGES
// import React, { Fragment, useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
// import AllTripsAPI from "../api/AllTripsAPI";
// import SpecialTripsAPI from "../api/SpecialTripsAPI";
// import NotFound from "../assets/media/page_not-found.jpg";
// import TripCard from "../components/TripCard";
// import TripsCardNew from "../components/TripsCardNew";

// const AllTrips = () => {
//   const sectionRefs = useRef({});
//   const location = useLocation();
//   const [isLoading, setIsLoading] = useState(true);

//   // State management
//   const [allTripsDetails, setAllTripsDetails] = useState([]);
//   const [specialTripsDetails, setSpecialTripsDetails] = useState([]);
//   const [error, setError] = useState(null);
//   const [selectedLocation, setSelectedLocation] = useState("");

//   const selectedState = location.state?.selectedState || null;

//   // Scroll to section when option is selected
//   const handleScroll = (e) => {
//     const selected = e.target.value;
//     const ref = sectionRefs.current?.[selected];
//     if (ref) {
//       ref.scrollIntoView({ behavior: "smooth", block: "start" });
//     }
//   };

//   // Fetch all regular trips data
//   useEffect(() => {
//     const fetchAllTrips = async () => {
//       try {
//         setIsLoading(true);
//         const res = await AllTripsAPI.getAllTrips();
//         const data = Array.isArray(res?.data) ? res.data : [];
//         setAllTripsDetails(data);
//       } catch (err) {
//         console.error("Error fetching all trips:", err);
//         setError("Unable to load trip data.");
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchAllTrips();
//   }, []);

//   // Fetch special trips data
//   useEffect(() => {
//     const fetchSpecialTrips = async () => {
//       try {
//         const res = await SpecialTripsAPI.getSpecialTrips();
//         const data = Array.isArray(res?.data) ? res.data : [];
//         setSpecialTripsDetails(data);
//       } catch (err) {
//         console.error("Error fetching special trips:", err);
//         setError("Unable to load special trip data.");
//       }
//     };
//     fetchSpecialTrips();
//   }, []);

//   // Scroll to selected state when coming from other page
//   useEffect(() => {
//     if (selectedState && sectionRefs.current?.[selectedState]) {
//       setTimeout(() => {
//         sectionRefs.current[selectedState]?.scrollIntoView({
//           behavior: "smooth",
//           block: "start",
//         });
//       }, 100);
//     }
//   }, [allTripsDetails, selectedState]);

//   const specialTrips = specialTripsDetails || [];

//   // Show loading state
//   if (isLoading) {
//     return (
//       <div className="text-center py-5">
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//         <p className="mt-3">Loading trips...</p>
//       </div>
//     );
//   }

//   // Show no data message
//   if (!isLoading && allTripsDetails.length === 0 && specialTrips.length === 0) {
//     return (
//       <div className="custom-alltrips-no-data-img">
//         <img src={NotFound} alt="No trips found" />
//       </div>
//     );
//   }

//   // Filter trips based on selected state
//   const filteredTrips = selectedState
//     ? allTripsDetails.filter((elem) => elem?.location === selectedState)
//     : allTripsDetails;

//   // Helper function to expand packages into individual batch-based trip cards
//   const expandPackagesToBatches = (packages) => {
//     const expandedTrips = [];
//     const seenKeys = new Set();

//     packages.forEach((pkg) => {
//       if (pkg.batches && Array.isArray(pkg.batches) && pkg.batches.length > 0) {
//         // Create a trip card for each batch
//         pkg.batches.forEach((batch) => {
//           // Create unique key to prevent duplicates
//           const uniqueKey = `${pkg.id}-${batch.id}`;

//           if (!seenKeys.has(uniqueKey)) {
//             seenKeys.add(uniqueKey);
//             expandedTrips.push({
//               // Package info
//               id: pkg.id,
//               title: pkg.title,
//               thumbnail_image: pkg.thumbnail_image,
//               slug: pkg.slug,
//               pickuploaction: pkg.pickuploaction,
//               duration_day: pkg.duration_day,
//               duration_night: pkg.duration_night,
//               price_per_persion: pkg.price_per_persion,
//               short_description: pkg.short_description,
//               trips_category: pkg.trips_category,
//               location: pkg.location,

//               // Batch info - this will be used for the date display
//               batch_id: batch.id,
//               batch_status: batch.batch_status,
//               batch_time: batch.batch_time,
//               batche_from: batch.batche_from,
//               batche_To: batch.batche_To,

//               // Keep the batches array for TripCard compatibility
//               batches: [batch],
//             });
//           }
//         });
//       } else {
//         // If no batches, add the package as-is (fallback)
//         const uniqueKey = `${pkg.id}-no-batch`;
//         if (!seenKeys.has(uniqueKey)) {
//           seenKeys.add(uniqueKey);
//           expandedTrips.push(pkg);
//         }
//       }
//     });

//     // Sort by batche_from date (earliest first)
//     expandedTrips.sort((a, b) => {
//       const dateA = a.batche_from ? new Date(a.batche_from) : new Date(0);
//       const dateB = b.batche_from ? new Date(b.batche_from) : new Date(0);
//       return dateA - dateB;
//     });

//     return expandedTrips;
//   };

//   return (
//     <section className="custom-all-trips-section container-fluid pb-5">
//       <div className="row">
//         {/* State Selection Dropdown */}
//         {!selectedState && (
//           <div className="col-lg-12 custom-all-trips-header px-4 py-3 d-flex justify-content-end">
//             <select
//               onChange={(e) => {
//                 setSelectedLocation(e.target.value);
//                 handleScroll(e);
//               }}
//               value={selectedLocation}
//             >
//               <option value="">All States</option>
//               {specialTrips.length > 0 && (
//                 <option value="special-trips">Special Trips</option>
//               )}
//               {allTripsDetails.map((elem, index) => {
//                 const locationName = elem?.location || `Unknown-${index}`;
//                 const id = elem?.packages?.[0]?.id || `trip-${index}`;
//                 return (
//                   <Fragment key={id}>
//                     <option value={locationName}>{locationName}</option>
//                   </Fragment>
//                 );
//               })}
//             </select>
//           </div>
//         )}

//         {/* Main Content */}
//         <div className="col-lg-12">
//           <div className="row d-flex justify-content-center">
//             <div className="col-lg-11 px-5 px-md-5 px-lg-5">
//               {/* Special Trips Section */}
//               {!selectedState && specialTrips.length > 0 && (
//                 <div
//                   key="special-trips"
//                   ref={(el) => (sectionRefs.current["special-trips"] = el)}
//                 >
//                   <h3
//                     className="my-2 w-100 custom-all-trips-font-size"
//                     style={{
//                       color: "#249acd",
//                       padding: "0 0 7px",
//                       borderBottom: "4px solid #f36d21",
//                       textTransform: "capitalize",
//                     }}
//                   >
//                     Special Trips
//                   </h3>
//                   <div className="row d-flex justify-content-center justify-content-md-start justify-content-lg-start">
//                     {specialTrips.map((trip, idx) =>
//                       trip ? (
//                         <TripCard
//                           key={trip.id || `special-${idx}`}
//                           trip={trip}
//                           showLocationInCard={true}
//                         />
//                       ) : null
//                     )}
//                   </div>
//                 </div>
//               )}

//               {/* Regular Trips Sections */}
//               {filteredTrips.map((elem, index) => {
//                 const locationName = elem?.location || `Unknown-${index}`;
//                 const packages = Array.isArray(elem?.packages)
//                   ? elem.packages
//                   : [];

//                 if (packages.length === 0) return null;

//                 // Expand packages to show each batch as a separate card
//                 const expandedTrips = expandPackagesToBatches(packages);

//                 return (
//                   <div
//                     key={`${locationName}-${index}`}
//                     ref={(el) => (sectionRefs.current[locationName] = el)}
//                   >
//                     <h3
//                       className="pt-3 w-100 custom-all-trips-font-size"
//                       style={{
//                         color: "#249acd",
//                         padding: "0 0 7px",
//                         borderBottom: "4px solid #f36d21",
//                         textTransform: "capitalize",
//                       }}
//                     >
//                       {locationName}
//                     </h3>

//                     <div className="row d-flex justify-content-center justify-content-md-start justify-content-lg-start">
//                       {expandedTrips.map((trip, idx) =>
//                         trip ? (
//                           <TripCard
//                             key={`${trip.id}-${trip.batch_id || idx}`}
//                             trip={trip}
//                             showLocationInCard={true}
//                           />
//                         ) : null
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}

//               {/* No trips message */}
//               {filteredTrips.length === 0 &&
//                 (!specialTrips.length || selectedState) && (
//                   <div className="text-center py-5">
//                     <h5 className="text-muted">No trips found</h5>
//                     <p className="text-muted">
//                       {selectedState
//                         ? `No trips available for ${selectedState}`
//                         : "Check back later for new trips"}
//                     </p>
//                   </div>
//                 )}

//               {/* Error message */}
//               {error && (
//                 <div className="text-center py-5">
//                   <h5 className="text-danger">{error}</h5>
//                   <p className="text-muted">Please try again later</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AllTrips;

import React, { Fragment, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import AllTripsAPI from "../api/AllTripsAPI";
import SpecialTripsAPI from "../api/SpecialTripsAPI";
import NotFound from "../assets/media/page_not-found.jpg";
import TripCard from "../components/TripCard";

const AllTrips = () => {
  const sectionRefs = useRef({});
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  // State management
  const [allTripsDetails, setAllTripsDetails] = useState([]);
  const [specialTripsDetails, setSpecialTripsDetails] = useState([]);
  const [error, setError] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");

  const selectedState = location.state?.selectedState || null;

  // Scroll to section when option is selected
  const handleScroll = (e) => {
    const selected = e.target.value;
    const ref = sectionRefs.current?.[selected];

    if (ref) {
      const yOffset = -100; // 👈 adjust based on your navbar height
      const y = ref.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  // Fetch all regular trips data
  useEffect(() => {
    const fetchAllTrips = async () => {
      try {
        setIsLoading(true);
        const res = await AllTripsAPI.getAllOverTrips();
        const data = Array.isArray(res?.data) ? res.data : [];
        setAllTripsDetails(data);
        console.log(data);
      } catch (err) {
        console.error("Error fetching all trips:", err);
        setError("Unable to load trip data.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllTrips();
  }, []);

  // Fetch special trips data
  useEffect(() => {
    const fetchSpecialTrips = async () => {
      try {
        const res = await SpecialTripsAPI.getSpecialTrips();
        const data = Array.isArray(res?.data) ? res.data : [];
        setSpecialTripsDetails(data);
      } catch (err) {
        console.error("Error fetching special trips:", err);
        setError("Unable to load special trip data.");
      }
    };
    fetchSpecialTrips();
  }, []);

  // Scroll to selected state when coming from other page
  useEffect(() => {
    if (selectedState && sectionRefs.current?.[selectedState]) {
      setTimeout(() => {
        const ref = sectionRefs.current[selectedState];
        if (ref) {
          const yOffset = -100; // 👈 adjust this based on your header height
          const y =
            ref.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 100);
    }
  }, [allTripsDetails, selectedState]);

  const specialTrips = specialTripsDetails || [];

  // Show loading state
  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Loading trips...</p>
      </div>
    );
  }

  // Show no data message
  if (!isLoading && allTripsDetails.length === 0 && specialTrips.length === 0) {
    return (
      <div className="custom-alltrips-no-data-img">
        <img src={NotFound} alt="No trips found" />
      </div>
    );
  }

  // Filter trips based on selected state
  const filteredTrips = selectedState
    ? allTripsDetails.filter((elem) => elem?.location === selectedState)
    : allTripsDetails;

  // Helper function to expand packages into individual batch-based trip cards
  // const expandPackagesToBatches = (packages) => {
  //   const expandedTrips = [];
  //   const seenKeys = new Set();

  //   packages.forEach((pkg) => {
  //     if (pkg.batches && Array.isArray(pkg.batches) && pkg.batches.length > 0) {
  //       pkg.batches.forEach((batch) => {
  //         const uniqueKey = `${pkg.id}-${batch.id}`;

  //         if (!seenKeys.has(uniqueKey)) {
  //           seenKeys.add(uniqueKey);
  //           expandedTrips.push({
  //             id: pkg.id,
  //             title: pkg.title,
  //             thumbnail_image: pkg.thumbnail_image,
  //             slug: pkg.slug,
  //             pickuploaction: pkg.pickuploaction,
  //             duration_day: pkg.duration_day,
  //             duration_night: pkg.duration_night,
  //             price_per_persion: pkg.price_per_persion,
  //             short_description: pkg.short_description,
  //             trips_category: pkg.trips_category,
  //             location: pkg.location,
  //             batch_id: batch.id,
  //             batch_status: batch.batch_status,
  //             batch_time: batch.batch_time,
  //             batche_from: batch.batche_from,
  //             batche_To: batch.batche_To,
  //             batches: [batch],
  //           });
  //         }
  //       });
  //     } else {
  //       const uniqueKey = `${pkg.id}-no-batch`;
  //       if (!seenKeys.has(uniqueKey)) {
  //         seenKeys.add(uniqueKey);
  //         expandedTrips.push(pkg);
  //       }
  //     }
  //   });

  //   // Sort by batche_from date (earliest first)
  //   expandedTrips.sort((a, b) => {
  //     const dateA = a.batche_from ? new Date(a.batche_from) : new Date(0);
  //     const dateB = b.batche_from ? new Date(b.batche_from) : new Date(0);
  //     return dateA - dateB;
  //   });

  //   return expandedTrips;
  // };

  // Helper function to expand packages into individual batch-based trip cards
  const expandPackagesToBatches = (packages) => {
    const expandedTrips = [];
    const seenKeys = new Set();

    packages.forEach((pkg) => {
      // Check if batches exists and is a string (date)
      if (pkg.batches && typeof pkg.batches === "string") {
        const uniqueKey = `${pkg.id}-${pkg.batches}`;

        if (!seenKeys.has(uniqueKey)) {
          seenKeys.add(uniqueKey);
          expandedTrips.push({
            ...pkg,
            // Create a batches array with a single batch object for compatibility
            batches: [
              {
                id: `batch-${pkg.id}`,
                batche_from: pkg.batches, // Use the date string from batches field
                batche_To: pkg.batches,
                batch_status: "active",
                batch_time: null,
              },
            ],
            batche_from: pkg.batches, // Add this for easy access
          });
        }
      } else {
        // Fallback for packages without batches
        const uniqueKey = `${pkg.id}-no-batch`;
        if (!seenKeys.has(uniqueKey)) {
          seenKeys.add(uniqueKey);
          expandedTrips.push(pkg);
        }
      }
    });

    // Sort by batche_from date (earliest first)
    expandedTrips.sort((a, b) => {
      const dateA = a.batche_from ? new Date(a.batche_from) : new Date(0);
      const dateB = b.batche_from ? new Date(b.batche_from) : new Date(0);
      return dateA - dateB;
    });

    return expandedTrips;
  };

  return (
    <section className="custom-all-trips-section pb-5">
      <div className="container-fluid">
        <div className="row">
          {/* State Selection Dropdown */}
          {!selectedState && (
            <div className="col-lg-12 custom-all-trips-header px-4 py-3 d-flex justify-content-end">
              <select
                onChange={(e) => {
                  setSelectedLocation(e.target.value);
                  handleScroll(e);
                }}
                value={selectedLocation}
              >
                <option value="">All States</option>
                {specialTrips.length > 0 && (
                  <option value="special-trips">Special Trips</option>
                )}
                {allTripsDetails.map((elem, index) => {
                  const locationName = elem?.location || `Unknown-${index}`;
                  const id = elem?.packages?.[0]?.id || `trip-${index}`;
                  return (
                    <Fragment key={id}>
                      <option value={locationName}>{locationName}</option>
                    </Fragment>
                  );
                })}
              </select>
            </div>
          )}
          {/* Main Content */}
          <div className="col-lg-12">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-11 px-5 px-md-5">
                {/* Special Trips Section */}
                {!selectedState && specialTrips.length > 0 && (
                  <div
                    key="special-trips"
                    ref={(el) => (sectionRefs.current["special-trips"] = el)}
                  >
                    <h3
                      className="my-2 w-100 custom-all-trips-font-size"
                      style={{
                        color: "#249acd",
                        padding: "0 0 7px",
                        borderBottom: "4px solid #f36d21",
                        textTransform: "capitalize",
                      }}
                    >
                      Special Trips ({specialTrips.length} trips)
                    </h3>
                    <Swiper
                      modules={[Navigation, Pagination]}
                      spaceBetween={20}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true }}
                      breakpoints={{
                        640: { slidesPerView: 2, spaceBetween: 20 },
                        768: { slidesPerView: 2, spaceBetween: 30 },
                        1024: { slidesPerView: 3, spaceBetween: 15 },
                        1440: { slidesPerView: 4, spaceBetween: 35 },
                      }}
                      className="my-3 custom-aligned-swiper custom-all-trips-slider-swiper-cont"
                    >
                      {specialTrips.map((trip, idx) =>
                        trip ? (
                          <SwiperSlide key={trip.id || `special-${idx}`}>
                            <TripCard
                              className="w-100"
                              trip={trip}
                              showLocationInCard={true}
                            />
                          </SwiperSlide>
                        ) : null
                      )}
                    </Swiper>
                  </div>
                )}
                {/* Regular Trips Sections */}
                {filteredTrips.map((elem, index) => {
                  const locationName = elem?.location || `Unknown-${index}`;
                  const packages = Array.isArray(elem?.packages)
                    ? elem.packages
                    : [];
                  if (packages.length === 0) return null;
                  const expandedTrips = expandPackagesToBatches(packages);
                  return (
                    <div
                      key={`${locationName}-${index}`}
                      ref={(el) => (sectionRefs.current[locationName] = el)}
                    >
                      <h3
                        className="pt-3 w-100 custom-all-trips-font-size"
                        style={{
                          color: "#249acd",
                          padding: "0 0 7px",
                          borderBottom: "4px solid #f36d21",
                          textTransform: "capitalize",
                        }}
                      >
                        {locationName} ({expandedTrips.length} trips)
                      </h3>
                      <Swiper
                        modules={[Navigation, Pagination]}
                        spaceBetween={20}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        breakpoints={{
                          640: { slidesPerView: 2, spaceBetween: 15 },
                          768: { slidesPerView: 2, spaceBetween: 30 },
                          1024: { slidesPerView: 3, spaceBetween: 15 },
                          1440: { slidesPerView: 4, spaceBetween: 12 },
                        }}
                        className="my-3 custom-aligned-swiper custom-all-trips-slider-swiper-cont"
                      >
                        {expandedTrips.map((trip, idx) =>
                          trip ? (
                            <SwiperSlide
                              key={`${trip.id}-${trip.batch_id || idx}`}
                            >
                              <TripCard trip={trip} showLocationInCard={true} />
                            </SwiperSlide>
                          ) : null
                        )}
                      </Swiper>
                    </div>
                  );
                })}
                {/* No trips message */}
                {filteredTrips.length === 0 &&
                  (!specialTrips.length || selectedState) && (
                    <div className="text-center py-5">
                      <h5 className="text-muted">No trips found</h5>
                      <p className="text-muted">
                        {selectedState
                          ? `No trips available for ${selectedState}`
                          : "Check back later for new trips"}
                      </p>
                    </div>
                  )}
                {/* Error message */}
                {error && (
                  <div className="text-center py-5">
                    <h5 className="text-danger">{error}</h5>
                    <p className="text-muted">Please try again later</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AllTrips;
